import { Modal, ModalProps } from './modal';
import { Button, EcommerceButton } from '../form/button';
import classNames from 'classnames';

type ConfirmModalProps = Omit<ModalProps, 'title'> & {
  onConfirm: () => any;
  prompt: string;
  yesButtonYellow?: boolean;
  yesLabel?: string;
  noLabel?: string;
  useEcommerceTheme?: boolean;
  disableButtons?: boolean;
  yesDataCy?: string;
  noDataCy?: string;
};

export const ConfirmModal = ({
  isOpen,
  close,
  onConfirm,
  headerIcon,
  prompt,
  additionalText,
  yesButtonYellow = false,
  yesLabel = 'Yes',
  noLabel = 'No',
  zIndex = 1000,
  useEcommerceTheme = false,
  disableButtons = false,
  yesDataCy = 'yes-button',
  noDataCy = 'no-button',
}: ConfirmModalProps) => {
  const CancelButton = () => {
    return useEcommerceTheme ? (
      <EcommerceButton buttonStyle="tertiary" onClick={close} disabled={disableButtons} dataCy={noDataCy}>
        {noLabel}
      </EcommerceButton>
    ) : (
      <Button className="button-block button-secondary" onClick={close} disabled={disableButtons} dataCy={noDataCy}>
        {noLabel}
      </Button>
    );
  };
  const ConfirmButton = () => {
    return useEcommerceTheme ? (
      <EcommerceButton buttonStyle="secondary" onClick={onConfirm} disabled={disableButtons} dataCy={yesDataCy}>
        {yesLabel}
      </EcommerceButton>
    ) : (
      <Button
        className={classNames({
          'button-primary': !yesButtonYellow,
          'button-yellow': yesButtonYellow,
        })}
        onClick={onConfirm}
        disabled={disableButtons}
        dataCy={yesDataCy}
      >
        {yesLabel}
      </Button>
    );
  };

  return (
    <Modal
      isOpen={isOpen}
      title={prompt}
      headerIcon={headerIcon}
      additionalText={additionalText}
      actions={
        <>
          <CancelButton />
          <ConfirmButton />
        </>
      }
      zIndex={zIndex}
      close={close}
    />
  );
};
